import { createContext } from 'react';
import { HostInfo } from '@hqo/hqo-miniapp-client-sdk';
import { HostPlatform } from 'shared/consts';

export interface HostInfoContextValue {
  hostPlatform?: HostPlatform;
  hostInfo?: HostInfo;
  /**
   * The host has answered, or there is no host to answer. Distinct from `hostPlatform` being set, which
   * stays undefined forever on a malformed payload — anything waiting on that alone would never fire.
   */
  isHostInfoSettled: boolean;
}

export const HostInfoContext = createContext<HostInfoContextValue>({ isHostInfoSettled: false });
